import { render, staticRenderFns } from "./SpellCard.vue?vue&type=template&id=6f3f4d68&scoped=true"
import script from "./SpellCard.vue?vue&type=script&lang=js"
export * from "./SpellCard.vue?vue&type=script&lang=js"
import style0 from "./SpellCard.vue?vue&type=style&index=0&id=6f3f4d68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f4d68",
  null
  
)

export default component.exports